import { render, staticRenderFns } from "./CategoryDialog.vue?vue&type=template&id=c096ba30&scoped=true"
import script from "./CategoryDialog.vue?vue&type=script&lang=js"
export * from "./CategoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c096ba30",
  null
  
)

export default component.exports